/**
 * Created by zad on 17/11/20.
 */
import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../components/Button/Button';

export default function ModalButton(props) {
  return (
    <Button {...props}/>
  );
}

ModalButton.displayName = 'Modal.Button';
ModalButton.propTypes = {
  type: PropTypes.string,
  className: PropTypes.string,
};



// WEBPACK FOOTER //
// ./src/components/Modal/ModalButton.js